window.theme = window.theme || {};
window.slate = window.slate || {};


(function($){

  var $ = jQuery = $;

  $('#specific-bulb').on('click',function(){
    $('.specific-bulb-field').toggleClass('hide');
    if($(this).is(":checked")){
      $('.bulb-field select').prop('disabled', 'disabled');
    }else{
      console.log('else');
      $('.bulb-field select').prop('disabled', false);
    }
  });

  $('.bulb-field select').on('change', function(){
    var val = $(this).val();
    var inputField = $(this).next('.specific-bulb-field').find('input');
    inputField.val(val);
  });

	/* product qty change event */
	//var qty_min_discount = 3;
	var qty_min_discount = 3;
	var variant_discount = "Discount";
	var variant_standard = "Standard";
	
	$("body").on("keyup", ".product__quantity input", function() {
		checkQtyVal();
	});	
	$("body").on("click", ".js-qty__adjust", function() {
		checkQtyVal();
	});
	
	function checkQtyVal() {
		var val = $(".product__quantity input").val();
		if(val >= qty_min_discount) {
			$("input[name=Price]").each(function() {
				if($(this).parent().data("value") == variant_discount) {
					$(this).parent().find("label").trigger("click");
				}
			});
		}
		else {
			$("input[name=Price]").each(function() {
				if($(this).parent().data("value") == variant_standard) {
					$(this).parent().find("label").trigger("click");
				}
			});
		}
	}
	
	/* cart update event */
	$(".template-cart input[name*=updates]").on("change", function() {
		$(".cart__total-label").parent().next().find("p").css("text-decoration", "line-through");
		if(!$(".update-cart-message").length) {
			$(".cart__total-label").parent().parent().after("<div class='update-cart-message' style='color: #db3876'>Your order quantity changed, please click 'Update Cart' to proceed</div>");
		}
	});
	
	/* count cart products qty per-collection */
	var cart_collections = {};
	$(".template-cart .cart__product-name").each(function(k, product) {
		var $product = $(product);
		$.each($product.data("collections").split("|"), function(j, collection) {
			if(cart_collections.hasOwnProperty(collection)) {
				cart_collections[collection] = cart_collections[collection] + $product.data("qty");
			}
			else {
				cart_collections[collection] = $product.data("qty");
			}
 		});
	});
	console.log("Cart collections:");
	console.log(cart_collections);
	
	/* update cart based on qty */
	$.getJSON("/cart.js", function(data) {
		var items = data.items;
		console.log(items);
		var needReload = 0;
		$(items).each(function(k, item) {
			console.log("Item: " + item.title);
			//get item's per-collection qty
			var isQtyCollectionGt = 0;
			var item_collections = $(".cart__product-name[data-productid="+item.product_id+"]").data("collections");
			$.each(item_collections.split("|"), function(j, collection) {
				if(cart_collections[collection] >= qty_min_discount) {
					isQtyCollectionGt = 1;
					console.log("Qty per-collection >= " + qty_min_discount + " (product qty: "+item.quantity+")")
				}
			});
			
			if((item.quantity >= qty_min_discount || isQtyCollectionGt) 
				&& item.variant_title == variant_standard
			) {
				//get new item variant
				var variantDiscount = $("a.cart__product-name[data-productid="+ item.product_id+"]").data("variant" + variant_discount.toLowerCase());
				if(variantDiscount) {
					// remove item for replace it by discount variant
					removeItemById(item.id);
					console.log("Adding new item with Discount variant " + variantDiscount);
					addItem(variantDiscount, item.quantity);
					needReload = 1;
				}
			}
			if(
				item.quantity < qty_min_discount && item.variant_title == variant_discount 
				&& isQtyCollectionGt == 0
			) {
				//get new item variant
				var variantNormal = $("a.cart__product-name[data-productid="+ item.product_id+"]").data("variant"+ variant_standard.toLowerCase());
				if(variantNormal) {
					// remove item for replace it by normal variant
					removeItemById(item.id);
					// add new item with normal variant
					console.log("Adding new item with Normal variant " + variantNormal);
					addItem(variantNormal, item.quantity);
					needReload = 1;
				}
			}
			if((k + 1) == items.length) {
				console.log("All cart items executed.");
				if(needReload) {
					window.location.reload();
				}
				else {
					$("#loadingScreen").hide();
				}
			}
		});
		if(!items.length) {
			$("#loadingScreen").hide();
		}
	});
	
	async function removeItemById(itemId) {
		var data = {
		  quantity: 0,
		  id: itemId
		};
		$.ajax({
		  type: 'post',
		  url: '/cart/change.js',
		  data: data,
		  success: function(d) { },
		  dataType: 'json',
		  async: false,
		});
	}
	
	async function addItem(product_id, quantity) {
		var data = {
		  items: [
			{
			  quantity: quantity,
			  id: product_id,
			}
		  ]
		};
		$.ajax({
		  type: 'post',
		  url: '/cart/add.js',
		  data: data,
		  success: function(d) { },
		  dataType: 'json',
		  async: false,
		});
	}
	
})(theme.jQuery);